<template>
    <div id="planning_bidang_urusan">

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Bidang</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button @click="getDataUrusan()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="row">
                    <div class="col-md-5">
                        <span class="huruf_input">Urusan Pemerintahan</span>
                        <select @change="changeUrusan($event)" v-model="filterUrusan" :required="true" class="form-control show-tick" tabindex="-98">
                            <option value="">-- Semua Urusan --</option>
                            <option v-for="(data) in list_urusan" :key="data.urusan_pemerintahan_id" v-bind:value="data.urusan_pemerintahan_id">	&#91;{{data.kode_urusan}}	&#93; {{data.nama_urusan}}</option>
                        </select>
                    </div>
                </div>
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th style="width: 5%">No.</th>
                            <!-- <th style="width: 15%">Kode Urusan</th> -->
                            <th style="width: 15%">Kode Bidang</th>
                            <th style="">Nama Bidang</th>
                            <th style="width: 15%">Pilihan</th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr class="h_isitable" v-for="(data, index) in list_bidang" :key="data.bidang_urusan_pemerintahan_id">
                              <td>{{index+1}}</td>
                              <!-- <td>{{data.kode_urusan}}</td> -->
                              <td>{{data.kode_urusan}}{{data.kode_bidang}}</td>
                              <td>{{data.nama_bidang}}</td>
                              <td class="text-center" >

                                <button @click="selectData(data)" class="btn bg-light-blue btn-xs waves-effect" title="Bidang Urusan Satuan Kerja" id="edit_data" data-toggle="modal" data-target="#m_instansi">
                                    <i class="material-icons" >link</i>
                                </button>
                                    &nbsp;
                                <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>
                                    &nbsp;
                                <button  @click="removeData(data.bidang_urusan_pemerintahan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>
                              </td>
                          </tr>
                          <tr v-if="list_bidang==0">
                            <td class="text-center" colspan="4">DATA KOSONG</td>
                          </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>

                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>

                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>



                <!-- ============================================================ MODAL ======================================================================== -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                    <br>
                                </div>

                                <form @submit.prevent="addData()">

                                <div class="modal-body">
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="">Nama Urusan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <select v-model="data.urusan_pemerintahan_id" :required="true" class="form-control show-tick" tabindex="-98">
                                                    <option value="" :disabled="true">-- Pilih Urusan --</option>
                                                    <option v-for="(data) in list_urusan" :key="data.urusan_pemerintahan_id" v-bind:value="data.urusan_pemerintahan_id">	&#91;{{data.kode_urusan}}&#93; {{data.nama_urusan}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Kode Bidang</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="data.kode_bidang" type="text" class="form-control" placeholder="Contoh: 01" :required="true">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Nama Bidang</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="data.nama_bidang" type="text" class="form-control" placeholder="Contoh: Urusan Wajib Pelayanan Dasar Pendidikan" :required="true">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button  type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                              </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                    <br>
                                </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body">

                                        <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="">Nama Urusan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <select v-model="data.urusan_pemerintahan_id" :required="true" class="form-control show-tick" tabindex="-98">
                                                    <option value="" :disabled="true">-- Pilih Urusan --</option>
                                                    <option v-for="(data) in list_urusan" :key="data.urusan_pemerintahan_id" v-bind:value="data.urusan_pemerintahan_id">	&#91;{{data.kode_urusan}}&#93; {{data.nama_urusan}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Kode Bidang</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="data.kode_bidang" type="text" class="form-control" placeholder="Contoh: 01" :required="true">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Nama Bidang</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="data.nama_bidang" type="text" class="form-control" placeholder="Contoh: Urusan Wajib Pelayanan Dasar Pendidikan" :required="true">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL INSTANSI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_instansi" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">INSTANSI PENYELENGGARA</h4>
                                    <br>
                                </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body">





                                        <div class="table-responsive">
                                            <table class="table table-bordered" style="width: 100%">
                                                <thead>
                                                <tr class="bg-info">
                                                    <th style="width: 5%">KODE</th>
                                                    <!-- <th style="width: 15%">Kode Urusan</th> -->
                                                    <th style="width: 15%">Kode Bidang</th>
                                                    <th style="">Nama Bidang</th>
                                                    <th style="width: 15%">Pilihan</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr class="h_isitable">
                                                    <td>010101</td>
                                                    <!-- <td>{{data.kode_urusan}}</td> -->
                                                    <td>xxxxxxxxxxxxxxx</td>
                                                    <td>xxxxxxxxxxxxxxx</td>
                                                    <td class="text-center" >
                                                        
                                                        <button  @click="removeData(data.bidang_urusan_pemerintahan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                            <i class="material-icons" >clear</i>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr v-if="list_bidang==0">
                                                    <td class="text-center" colspan="4">DATA KOSONG</td>
                                                </tr>

                                                </tbody>
                                            </table>
                                        </div>









   

                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL INSTANSI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                 <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST INSTANSI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">PILIH INSTANSI</h4>
                                    <br>
                                </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body">

   

                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST INSTANSI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->



                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL_URUSAN = URL_APP+'api/v1/planning_urusan/';
    const ADD_URL = URL_APP+'api/v1/planning_bidang/';
    const ADD_URL_SKPD = URL_APP+'api/v1/planning_satker/';

    const ADD_URL_INSTANSI = URL_APP+'api/v1/simpeg_instansi/';


    export default {
        name: "planning_bidang_urusan",
        data() {
            return {
                data:{
                    id: '',
                    urusan_pemerintahan_id: '',
                    kode_bidang: '',
                    nama_bidang: ''
                },
                dataSKPD:{
                    bidang_id: '',
                    skpd_id_array: [],
                },
                kode_bidang: '',
                nama_bidang: '',
                bidang_urusan_pemerintahan_id: '',
                urusan_pemerintahan_id: '',
                list_urusan: [],
                list_bidang: [],
                list_skpd: [],
                list_skpd_relate: [],
                filterUrusan: '',
                
                page_first : 1,
                page_last : 0,
                cari_value : '',

                // new
                temp_id : '',
                select_urusan_edit: '',
            };
        },

        mounted() {
            this.getData();
            this.getDataUrusan();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            changeUrusan: function(ev){
              this.filterUrusanFunction(this.filterUrusan);
              // console.log(this.filterUrusan);
              // console.log("");
            },
            filterUrusanFunction: function(id){
              if(id == ''){
                  this.getData();
              }else{
                fetch(ADD_URL+'getData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      id: id
                    })
                }).then((res) => res.json()).then((data_bidang) => {
                  this.list_bidang = data_bidang.data;
                  this.page_last = data_bidang.jml_data;
                  console.log(this.list_bidang);
                })
              }
            },
            addtoArray: function(a){
                let cb = document.getElementById(a).checked

                if (cb == true){
                    this.dataSKPD.skpd_id_array.push(a);
                } else {
                    this.dataSKPD.skpd_id_array.pop(a);
                }
                console.log(JSON.stringify(this.dataSKPD));
            },
            addDataSKPD: function(){
                console.log(JSON.stringify(this.dataSKPD));
                fetch(ADD_URL+'addDataLink', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.dataSKPD)
                }).then(res => res.json()).then((data_bidang) => {
                    // console.log(data_bidang);
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getDataSKPD();
                    this.getDataSKPDandBidang();
                });
            },
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then(res => res.json()).then((data_bidang) => {
                  console.log(data_bidang);
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_bidang) => {
                  this.list_bidang = data_bidang.data;
                  this.page_last = data_bidang.jml_data;
                })
            },
            getDataUrusan: function(){
                fetch(ADD_URL_URUSAN+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_urusan) => {
                  this.list_urusan = data_urusan.data;
                  this.page_last = data_urusan.jml_data;
                })
            },
            getDataSKPD: function(){
                fetch(ADD_URL_SKPD+'readDataLink', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      id_bidang : this.dataSKPD.bidang_id,
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_urusan) => {
                  this.list_skpd = data_urusan.data;
                })
            },
            getDataSKPDandBidang: function(){
                fetch(ADD_URL_SKPD+'readDataLinkBidang', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      id_bidang : this.dataSKPD.bidang_id,
                    })
                }).then((res) => res.json()).then((data_urusan) => {
                  this.list_skpd_relate = data_urusan.data;
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.changeUrusan('nope');
                    // this.getData();
                });
            },
            selectData : function(dataGet){
                console.log(dataGet);

                    this.data.id = dataGet.bidang_urusan_pemerintahan_id;
                    this.data.urusan_pemerintahan_id= dataGet.urusan_pemerintahan_id;
                    this.data.kode_bidang= dataGet.kode_bidang;
                    this.data.nama_bidang= dataGet.nama_bidang;

            },

            triggerSKPD : function(){
              this.getDataSKPD();
              this.dataSKPD.skpd_id_array = [] ;
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.changeUrusan('nope');
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            removeDataRelate : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL_SKPD+"deleteDataRelate", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getDataSKPDandBidang();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.data={
                    id: '',
                    kode_urusan: '',
                    kode_bidang: '',
                    nama_bidang: ''
                }
            },

        //=================== TAMBAHAN ===================

        //=================== TAMBAHAN ===================


        //=================== PAGINASI ===================
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
              if(this.page_first>1){
                this.page_first--
              }else{
                this.page_first = 1;
              }
              this.getData();
            },

            btn_next : function(){
              if(this.page_first >= this.page_last){
                this.page_first == this.page_last
              }else{
                this.page_first++;
              }
              this.getData();
            },

            cari_data : function(){
              this.getData();
            }
        //=================== PAGINASI ===================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
